import React from 'react'
import { Row, Col } from 'react-bootstrap'
import UseAdminGetOrderDetails from '../../CustomHooks/Admin/UseAdminGetOrderDetails'
import UserAllOrderItem from '../User/UserAllOrderItem'
import { ToastContainer } from 'react-toastify'

const AdminOrderDetailsComp = () => {
    const [orderDetails, handleChangePaidCase, changePayRequest, handleChangeDeliverCase, changeDeliverRequest, deliverDisabledStatus, paidDisabledStatus] = UseAdminGetOrderDetails()

    return (
        <>
            {orderDetails && orderDetails.data ? (<UserAllOrderItem item={orderDetails.data.data} />) : null}
            <Row className="mt-5 mx-3 p-3 shadow">
                <Col xs="12" className="d-flex">
                    <div className="py-2 fw-bold fs-20 mb-4"> User Details </div>
                </Col>
                <Col xs="12">
                    <p><strong>Name:</strong>  {orderDetails && orderDetails.data ? orderDetails.data.data.user.name : null}</p>
                    <p><strong> Mobile Number :</strong>  {orderDetails && orderDetails.data ? orderDetails.data.data.user.phone : null}</p>
                    <p><strong> email :</strong>   {orderDetails && orderDetails.data ? orderDetails.data.data.user.email : null}</p>
                    <p><strong> Total :</strong>  {orderDetails && orderDetails.data ? orderDetails.data.data.totalOrderPrice : null}</p>
                </Col>
            </Row>
            <Row className="mx-3">
                <Col md="6" className="d-flex mt-5 justify-content-md-end justify-content-center">
                    <select
                        name="paid"
                        id="paid"
                        disabled={paidDisabledStatus}
                        onChange={handleChangePaidCase}
                        className="form-select text-center px-2 w-200px h-50px rounded-0">
                        <option value="0"> Paid status </option>
                        <option value="false"> Not Paid</option>
                        <option value="true">Paid</option>
                    </select>
                    <button className="px-5 d-inline mx-2 rounded-0 h-50px dark-bg border-0 text-white" onClick={changePayRequest}> save </button>
                </Col>
                <Col md="6" className="d-flex mt-md-5 mt-3 justify-content-md-start justify-content-center mb-5">
                    <select
                        name="deleivery"
                        id="deleivery"
                        onChange={handleChangeDeliverCase}
                        disabled={deliverDisabledStatus}
                        className="form-select text-center px-2 w-200px h-50px  rounded-0">
                        <option value="0"> delivery status </option>
                        <option value="false"> Not delivery</option>
                        <option value="true">delivery</option>
                    </select>
                    <button className="px-5 d-inline mx-2 rounded-0 h-50px dark-bg border-0 text-white" onClick={changeDeliverRequest}> save </button>
                </Col>
            </Row>
            <ToastContainer limit={1} />
        </>
    )
}

export default AdminOrderDetailsComp
